import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { createPollEvent } from '../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../analytics/functions';
// import { IReduxState } from '../../app/types';
import { COMMAND_NEW_POLL, POLL_TYPE } from '../constants';
import { getParticipantDisplayName } from "../../base/participants";
/**
 * Higher Order Component taking in a concrete PollCreate component and
 * augmenting it with state/behavior common to both web and native implementations.
 *
 * @param {React.AbstractComponent} Component - The concrete component.
 * @returns {React.AbstractComponent}
 */
const AbstractPollCreate = (Component) => (props) => {
    const { setCreateMode } = props;
    const [question, setQuestion] = useState('');
    const [pollType, setPollType] = useState(POLL_TYPE.MULTI_SELECT);
    const [answers, setAnswers] = useState(['', '']);
    const setAnswer = useCallback((i, answer) => {
        answers[i] = answer;
        setAnswers([...answers]);
    }, [answers]);
    const addAnswer = useCallback((i) => {
        const newAnswers = [...answers];
        sendAnalytics(createPollEvent('option.added'));
        newAnswers.splice(typeof i === 'number' ? i : answers.length, 0, '');
        setAnswers(newAnswers);
    }, [answers]);
    const removeAnswer = useCallback(i => {
        if (answers.length <= 2) {
            return;
        }
        const newAnswers = [...answers];
        sendAnalytics(createPollEvent('option.removed'));
        newAnswers.splice(i, 1);
        setAnswers(newAnswers);
    }, [answers]);
    const conference = useSelector((state) => { var _a; return (_a = state['features/base/conference']) === null || _a === void 0 ? void 0 : _a.conference; });
    const myId = conference.myUserId();
    const myName = useSelector(state => getParticipantDisplayName(state, myId));
    const onSubmit = useCallback(ev => {
        if (ev) {
            ev.preventDefault();
        }
        const filteredAnswers = answers.filter(answer => answer.trim().length > 0);
        if (filteredAnswers.length < 2) {
            return;
        }
        conference === null || conference === void 0 ? void 0 : conference.sendMessage({
            type: COMMAND_NEW_POLL,
            pollId: Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(36),
            question,
            answers: filteredAnswers,
            pollType,
            senderId: myId,
            senderName: myName,
        });
        sendAnalytics(createPollEvent('created'));
        setCreateMode(false);
    }, [conference, question, answers, pollType]);
    // Check if the poll create form can be submitted i.e. if the send button should be disabled.
    const isSubmitDisabled = question.trim().length <= 0 // If no question is provided
        || answers.filter(answer => answer.trim().length > 0).length < 2; // If not enough options are provided
    const { t } = useTranslation();
    return (React.createElement(Component, { addAnswer: addAnswer, answers: answers, isSubmitDisabled: isSubmitDisabled, onSubmit: onSubmit, pollType: pollType, question: question, removeAnswer: removeAnswer, setAnswer: setAnswer, setCreateMode: setCreateMode, setPollType: setPollType, setQuestion: setQuestion, t: t }));
};
export default AbstractPollCreate;
